import React, {useEffect, useState} from 'react';
import {Button, Form, Modal, Select} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {fetchCourseCategories, postCourses, putPeopleCourse} from "../../../../redux/actions";

export const TrackingForm = ({show, item, onCancel, onSuccess}) => {

    const {register, handleSubmit, formState} = useForm({
        mode: "onBlur",
        defaultValues: {
            id: item.id,
            rastreio: item.rastreio,
        }
    });

    const onSubmit = async data => {

        try {
            const res = await putPeopleCourse(data);

            onSuccess(res.data);
        } catch (e) {
            alert('error')
        }
    };

    return (
        <Modal open={show} size={'tiny'}>
            <Modal.Header>Editar código de rastreio</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Form id={'form'} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
                        <input type={'hidden'} name={'id'} value={item.id} ref={register()}/>
                        <Form.Field>
                            <label>Código</label>
                            <input
                                name={'rastreio'}
                                ref={register({required: true})}
                                defaultValue={item.rastreio}
                                autoFocus
                            />
                        </Form.Field>
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button basic content={'Cancelar'} onClick={onCancel}/>
                <Button
                    positive
                    content="Salvar"
                    form={'form'}
                />
            </Modal.Actions>
        </Modal>
    )
}